'use strict';

var voGallery = function () {
  var $imgContainer = void 0,
      $thumbContainer = void 0,
      gallerySlider = void 0;
  var _init = function _init(json, params, vehicleName) {
    var imgUrls = json.matrizImg,
        thumbUrls = json.matrizImgthumb;
    $imgContainer = $(params.principal);
    $thumbContainer = $(params.thumbnails);
    $imgContainer.empty();
    $thumbContainer.empty();

    for (var i = 0; i < imgUrls.length; i++) {
      // let $itA = `<div><img src="" title=""/></div>`
      var $itA = $('<div/>');
      $itA.addClass('vo-gallery-img').css('background-image', 'url(\'' + globalEnvStatic + imgUrls[i] + '\')');
      var $itB = $('<div/>');
      $itB.addClass('vo-gallery-th js-thumb-item').attr('data-slide', '' + i).html('<img src="' + globalEnvStatic + thumbUrls[i] + '" alt="' + vehicleName + '"/>');

      $itB.on('click', function () {
        _controlNav($(this));
      });
      $imgContainer.append($itA);
      $thumbContainer.append($itB);
    }

    _mountSlick();
  };

  var _mountSlick = function _mountSlick() {
    gallerySlider = $imgContainer.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      adaptiveHeight: false,
      infinite: false,
      useTransform: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
    });

    gallerySlider.on('afterChange', function (event, slick, currentSlide) {
      var $thumb = $thumbContainer.find('.js-thumb-item');
      var $myThumb = $thumbContainer.find('.js-thumb-item[data-slide = ' + currentSlide + ']');
      $thumb.removeClass('active');
      $myThumb.addClass('active');
    });
  };

  var _controlNav = function _controlNav($trigger) {
    $trigger.addClass('active').siblings().removeClass('active');
    var nSlide = $trigger.data('slide');
    gallerySlider.slick('slickGoTo', nSlide);
  };

  return {
    init: _init
  };
}();